const details = {
    name: "بازرگانی نور گستران آیین پارس",
    enName: "shop",
    description: "بازرگانی نور گستران آیین پارس",

    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "طراحی سایت فروش کالا",
        link: "https://barantm.com/landing/onlineshop-webdesign"
    }
}

export default details;
